<div class="chatWrapper">
   <iframe class="chatroom" [src]='safeUrl' allow="autoplay"></iframe>
</div>
